import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchClaimTypesByPolicyTypeAndClaimCategoryFailedAction,
    fetchClaimTypesByPolicyTypeAndClaimCategorySuccessAction,
} from '../actions/claimType';
type State = {
    claimType: {
        byId: { [id: string]: any } | null;
        allIds: Array<string> | [];
    };
    loading: boolean;
    errorMessage: null | any;
    claimFormType: {
        byId: { [id: string]: any } | null;
        allIds: Array<string> | [];
    };
};
const INITIAL_STATE: State = {
    claimType: {
        byId: {},
        allIds: [],
    },
    loading: false,
    errorMessage: null,
    claimFormType: {
        byId: {},
        allIds: [],
    },
};

const fetchClaimTypes = (state: State): State => {
    return state;
};

const fetchClaimTypesSuccess = (state: State): State => {
    return state;
};

const fetchClaimTypesFailed = (state: State): State => {
    return state;
};

const fetchClaimTypesByPolicyTypeAndClaimCategory = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchClaimTypesByPolicyTypeAndClaimCategorySuccess = (
    state: State,
    action: PayloadAction<fetchClaimTypesByPolicyTypeAndClaimCategorySuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        claimType: {
            ...state.claimType,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchClaimTypesByPolicyTypeAndClaimCategoryFailed = (
    state: State,
    action: PayloadAction<fetchClaimTypesByPolicyTypeAndClaimCategoryFailedAction>,
): State => {
    return {
        ...state,
        errorMessage: action.payload.body,
        loading: false,
    };
};

const clearClaimTypesState = (): State => {
    return INITIAL_STATE;
};

const claimType = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_CLAIM_TYPES]: fetchClaimTypes,
    [ActionTypes.FETCH_CLAIM_TYPES_SUCCESS]: fetchClaimTypesSuccess,
    [ActionTypes.FETCH_CLAIM_TYPES_FAILED]: fetchClaimTypesFailed,
    [ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY]:
        fetchClaimTypesByPolicyTypeAndClaimCategory,
    [ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_SUCCESS]:
        fetchClaimTypesByPolicyTypeAndClaimCategorySuccess,
    [ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_FAILED]:
        fetchClaimTypesByPolicyTypeAndClaimCategoryFailed,
    [ActionTypes.CLEAR_CLAIM_TYPES_STATE]: clearClaimTypesState,
    [ActionTypes.REDIRECT_AFTER_CLAIM_SUBMIT]: clearClaimTypesState,
});

export default claimType;
